// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADocumentContentAssessmentsInner
 */
export interface DTADocumentContentAssessmentsInner {
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentAssessmentsInner
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentAssessmentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentAssessmentsInner
     */
    reference_section?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DTADocumentContentAssessmentsInner
     */
    scheduled_visits?: Array<number>;
}

/**
 * Check if a given object implements the DTADocumentContentAssessmentsInner interface.
 */
export function instanceOfDTADocumentContentAssessmentsInner(value: object): value is DTADocumentContentAssessmentsInner {
    return true;
}

export function DTADocumentContentAssessmentsInnerFromJSON(json: any): DTADocumentContentAssessmentsInner {
    return DTADocumentContentAssessmentsInnerFromJSONTyped(json, false);
}

export function DTADocumentContentAssessmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContentAssessmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'name': json['name'] == null ? undefined : json['name'],
        'reference_section': json['reference_section'] == null ? undefined : json['reference_section'],
        'scheduled_visits': json['scheduled_visits'] == null ? undefined : json['scheduled_visits'],
    };
}

export function DTADocumentContentAssessmentsInnerToJSON(json: any): DTADocumentContentAssessmentsInner {
    return DTADocumentContentAssessmentsInnerToJSONTyped(json, false);
}

export function DTADocumentContentAssessmentsInnerToJSONTyped(value?: DTADocumentContentAssessmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'name': value['name'],
        'reference_section': value['reference_section'],
        'scheduled_visits': value['scheduled_visits'],
    };
}
